import classNames from "classnames";
import cssButtonStyles from "src/components/button/Button.module.css";
import FilmwebLink from "src/components/filmweblink/FilmwebLink";
import styles from "./ButtonLink.module.css";
import type { DkVariantDark, DkVariantDarkOutline, DkVariantRed } from "src/lib/types/dk/DkVariants";

//#region [Props]
type ButtonLinkProps = {
    className?: string;
    inverse?: boolean;
    isOutline?: boolean;
    children: React.ReactNode;
    href: string;
    target?: string;
    borderStyle?: "round" | "square";
	prefetch?: boolean;
    dkVariant?: DkVariantRed | DkVariantDark | DkVariantDarkOutline;
};
//#endregion

//#region [Component]
export default function ButtonLink({ className, inverse = false, isOutline = false, href, children, target, borderStyle = "round", prefetch, dkVariant }: ButtonLinkProps) {
    const buttonStyles = process.env.NEXT_PUBLIC_WEBSITE_BRAND === "kinodk" ?
        {
            "themedk": true,
            [styles.ThemeDk]: true,
            [styles.Variant_Red]: dkVariant === "red",
            [styles.Variant_Dark]: dkVariant === "dark",
            [styles.Variant_DarkOutline]: dkVariant === "darkOutline",
        } :
        {
            "themefw": true,
            [styles.ThemeFw]: true,
        }

    // FilmwebLink makes links to our own site relative, uses next/link for those and a plain <a> for other sites
    return <FilmwebLink to={href} target={target} prefetch={prefetch} className={classNames(cssButtonStyles.CoreButton, styles.ButtonLink, className, {
        ...buttonStyles,
        [cssButtonStyles.square]: borderStyle === 'square',
        [cssButtonStyles.inverse]: inverse,
        [cssButtonStyles.outline]: isOutline
    })}>{children}
    </FilmwebLink>;
}
//#endregion